import {h, Fragment} from "preact"
import { usePagination, useActions } from "@nosto/preact"
import { PAGINATION_WIDTH } from "../config"

function PageLink({ onClick, href, className, ariaLabel, children }) {
    return (
        <a
            class={`pagination__link text-current underline underline--on-hover ${className}`}
            href={href}
            aria-label={ariaLabel}
            onClick={onClick}
        >
            {children}
        </a>
    )
}

export default function Pagination() {
    const { prev, first, pages, last, next } = usePagination({
        width: PAGINATION_WIDTH
    })

    const { updateSearch, simulateUpdateSearch } = useActions()

    function pageLinkProps({ from }) {
        return {
            onClick: e => {
                e.preventDefault()
                updateSearch({ products: { from } })
                scrollTo(0, 0)
            },
            href: simulateUpdateSearch({ products: { from } }).url
        }
    }

    return (
        <div class="container pagination-row">
            <div class="pagination">
                {prev && (
                    <>
                        <PageLink 
                            {...pageLinkProps(prev)} 
                            className="pagination__prev" 
                            ariaLabel="Previous page"
                        >
                            « Previous
                        </PageLink>
                        <span class="pagination__sep">·</span>
                    </>
                )}

                {first && (
                    <>
                        <span class="pagination__number">
                            <PageLink {...pageLinkProps(first)} ariaLabel="First page">
                                {first.page}
                            </PageLink>
                        </span>
                        <span class="pagination__number">...</span>
                    </>
                )}

                {pages.map(page => (
                    <>
                        {page.current ? (
                            <span class="pagination__number underline underline--not-link">
                                {page.page}
                            </span>
                        ) : (
                            <span class="pagination__number">
                                <PageLink 
                                    ariaLabel={`${page.page} page`} 
                                    {...pageLinkProps(page)}
                                >
                                    {page.page}
                                </PageLink>
                            </span>
                        )}
                    </>
                ))}

                {last && (
                    <>
                        <span class="pagination__number">...</span>
                        <span class="pagination__number">
                            <PageLink {...pageLinkProps(last)} ariaLabel="Last page">
                                {last.page}
                            </PageLink>
                        </span>
                    </>
                )}

                {next && (
                    <>
                        <span class="pagination__sep">·</span>
                        <PageLink 
                            {...pageLinkProps(next)} 
                            className="pagination__next" 
                            ariaLabel="Next page"
                        >
                            Next »
                        </PageLink>
                    </>
                )}
            </div>
        </div>
    )
}